import React from 'react'
import About from '../components/About/About'
import Contact from '../components/Contact/Contact'
import Footer from '../components/Footer/Footer'
import Hero from '../components/Hero/Hero'
import Navbar from '../components/Navbar/Navbar'
import Portfolio from '../components/Portfolio/Portfolio'
import Skills from '../components/Skills/Skills'

const Home = () => {
  return (
    <div>
        <Navbar />
        <Hero />
        <About />
        <Skills />
        <Portfolio />
        <Contact />
        <Footer />
    </div>
  )
}

export default Home